import { globalEntitlements } from '../utils/globalEntitlements';

export const CORPORATE_BYLAWS_CONFIG = {
  hero: {
    buyBox: [{
      bulletPoints: [
        { title: 'productPage.corporateBylaws.buyBox.bulletPoint1' },
        { title: 'productPage.corporateBylaws.buyBox.bulletPoint2' },
        { title: 'productPage.corporateBylaws.buyBox.bulletPoint3' }
      ],
      productName: 'productPage.corporateBylaws.buyBox.productName',
      interactService: {
        service: 'operating_agreement',
        ctaType: 'internalCheckout'
      }
    }],
    headerPicture: {
      src: '/s2/raster/laptop-ceramics-chat.png',
      alt: 'productPage.corporateBylaws.heroPicture.altText'
    },
    headline: 'productPage.corporateBylaws.page.headline',
    partnerLogo: {},
    partnerReviewBlanks: [],
    subheader: 'productPage.corporateBylaws.page.subheader'
  },
  benefit: {
    title: 'productPage.corporateBylaws.valueProp.title',
    items: [
      {
        icon: '/s2/material-icons/shieldrounded.svg',
        title: 'productPage.corporateBylaws.valueProp.propTitle1',
        description: 'productPage.corporateBylaws.valueProp.shortCopy1'
      },
      {
        icon: '/s2/material-icons/thumbuprounded.svg',
        title: 'productPage.corporateBylaws.valueProp.propTitle2',
        description: 'productPage.corporateBylaws.valueProp.shortCopy2'
      },
      {
        icon: '/s2/material-icons/personaddaltrounded.svg',
        title: 'productPage.corporateBylaws.valueProp.propTitle3',
        description: 'productPage.corporateBylaws.valueProp.shortCopy3'
      }
    ]
  },
  highlight: {
    icon: '/s2/material-icons/gavelrounded.svg',
    title: 'productPage.corporateBylaws.topFeature.title',
    subheader: 'productPage.corporateBylaws.topFeature.subheader',
    image: '/s2/raster/sign-shop-open.png',
    alt: 'productPage.corporateBylaws.topFeature.altText'
  },
  howItWorks: {
    title: 'productPage.corporateBylaws.howItWorks.title',
    items: [
      {
        title: 'productPage.corporateBylaws.howItWorks.step1',
        description: 'productPage.corporateBylaws.howItWorks.shortDescription1'
      },
      {
        title: 'productPage.corporateBylaws.howItWorks.step2',
        description: 'productPage.corporateBylaws.howItWorks.shortDescription2'
      },
      {
        title: 'productPage.corporateBylaws.howItWorks.step3',
        description: 'productPage.corporateBylaws.howItWorks.shortDescription3'
      }
    ],
    image: '/s2/raster/store-clothes-smiling.png',
    alt: 'productPage.corporateBylaws.howItWorks.altText',
    hasNumber: true,
    hasDivider: false,
    hasMobileImage: true
  },
  faqs: {
    title: 'productPage.corporateBylaws.frequentlyAskedQuestions.title',
    items: [
      {
        question: 'productPage.corporateBylaws.frequentlyAskedQuestions.faq1',
        answer: 'productPage.corporateBylaws.frequentlyAskedQuestions.faqAnswer1'
      },
      {
        question: 'productPage.corporateBylaws.frequentlyAskedQuestions.faq2',
        answer: 'productPage.corporateBylaws.frequentlyAskedQuestions.faqAnswer2'
      },
      {
        question: 'productPage.corporateBylaws.frequentlyAskedQuestions.faq3',
        answer: 'productPage.corporateBylaws.frequentlyAskedQuestions.faqAnswer3'
      }
    ]
  },
  assistance: {
    title: 'productPage.corporateBylaws.needAssistance.title',
    getInTouch: 'productPage.corporateBylaws.needAssistance.getInTouch',
    actions: 'productPage.corporateBylaws.needAssistance.actions'
  },
  getBuyButtonConfig: globalEntitlements({ ctaText: 'productPage.corporateBylaws.buyBox.buttonLabel' })
    .formedByZb()
    .businessFormed()
    .currentProductNotPurchased()
    .build()
};
